import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quaryContent: null,
  queryModules: null,
  isLoading: true,
  isLoadingButtonCreate: false,
  isLoadingButtonEdit: false,
  selectedDatabase: null,
  selectedType: null,
  selectedQueryName: null,
  selectedId: null,
  queryContentSingle: null,
  isPaginationOrSearchClicked: true,
  createQueryFormData: {
    queryName: "",
    database: null,
    queryDescription: "",
    requestSql: "",
    modules: null,
    type: null,
    confluence_url: null,
  },
  createQueryFormDataInput: {},
  editQueryFormDataInput: {},
  hasError: false,
  dbMetadataPayload: null,
  dbMetaDataPostFailed: false,
  createBizQueryFailed: false,
  outputValues: null,
  createBizQueryPayload: null,
  editBizQueryPayload: null,
  editableOutputValues: [],
  hasErrorMessage: null,
  // for edit portion
  editId: null,
  editQueryFormData: {
    name: "",
    database: null,
    description: "",
    query: "",
    modules: null,
    type: null,
    confluence_url: null,
  },
  editLoading: false,
  localMergedOutputData: [],
  editCompleted: false,
  selectedModules: null,
  runQueryLoading: false,
  runQueryButtonLoading: false,
  queryOutputTableData: null,
};

const dataStoreReqSlice = createSlice({
  name: "dataStoreReq",
  initialState,
  reducers: {
    setQuaryContent: (state, action) => {
      state.quaryContent = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsLoadingButtonCreate: (state, action) => {
      state.isLoadingButtonCreate = action.payload;
    },
    setIsLoadingButtonEdit: (state, action) => {
      state.isLoadingButtonEdit = action.payload;
    },
    setSelectedDatabase: (state, action) => {
      state.selectedDatabase = action.payload;
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
    },
    setSelectedQueryName: (state, action) => {
      state.selectedQueryName = action.payload;
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setQueryContentSingle: (state, action) => {
      state.queryContentSingle = action.payload;
    },
    setIsPaginationOrSearchClicked: (state, action) => {
      state.isPaginationOrSearchClicked = action.payload;
    },
    setCreateQueryFormData: (state, action) => {
      state.createQueryFormData = {
        ...state.createQueryFormData,
        ...action.payload,
      };
    },
    setEditQueryFormData: (state, action) => {
      state.editQueryFormData = {
        ...state.editQueryFormData,
        ...action.payload,
      };
    },
    setHasError: (state, action) => {
      state.hasError = action.payload;
    },
    setCreateQueryFormDataInput: (state, action) => {
      if (action.payload.__replace) {
        state.createQueryFormDataInput = action.payload.data;
      } else {
        state.createQueryFormDataInput = {
          ...state.createQueryFormDataInput,
          ...action.payload,
        };
      }
    },
    setEditQueryFormDataInput: (state, action) => {
      if (action.payload.__replace) {
        state.editQueryFormDataInput = action.payload.data;
      } else {
        state.editQueryFormDataInput = {
          ...state.editQueryFormDataInput,
          ...action.payload,
        };
      }
    },
    setDbMetadataPayload: (state, action) => {
      state.dbMetadataPayload = action.payload;
    },
    setDbMetaDataPostFailed: (state, action) => {
      state.dbMetaDataPostFailed = action.payload;
    },
    setCreateBizQueryFailed: (state, action) => {
      state.createBizQueryFailed = action.payload;
    },
    setOutputValues: (state, action) => {
      state.outputValues = action.payload;

      // initialize editable version
      state.editableOutputValues = action.payload.fields.map(
        (field: any, index: any) => ({
          id: index,
          name: field.name,
          type: field.type,
          title: "",
          description: "",
          order: "",
          value_for_test: "",
        })
      );
    },
    setCreateBizQueryPayload: (state, action) => {
      state.createBizQueryPayload = action.payload;
    },
    setEditBizQueryPayload: (state, action) => {
      state.editBizQueryPayload = action.payload;
    },
    setEditableOutputValues: (state, action) => {
      state.editableOutputValues = action.payload;
    },
    updateEditableOutputField: (state, action) => {
      const { id, key, value } = action.payload;
      const fieldToUpdate = state.editableOutputValues.find(
        (f: any) => f.id === id || f.name === id
      ) as any;
      if (fieldToUpdate) {
        fieldToUpdate[key] = value;
      }
    },
    setHasErrorMessage: (state, action) => {
      state.hasErrorMessage = action.payload;
    },
    setEditId: (state, action) => {
      state.editId = action.payload;
    },
    setEditLoading: (state, action) => {
      state.editLoading = action.payload;
    },
    setLocalMergedOutputData: (state, action) => {
      state.localMergedOutputData = action.payload;
    },
    updateLocalMergedOutputData: (state: any, action) => {
      const { id, key, value } = action.payload;
      state.localMergedOutputData = state.localMergedOutputData.map(
        (item: any) => (item.id === id ? { ...item, [key]: value } : item)
      );
    },
    resetLocalMergedOutputData: (state) => {
      state.localMergedOutputData = [];
    },
    setEditCompleted: (state, action) => {
      state.editCompleted = action.payload;
    },
    setSelectedModules: (state, action) => {
      state.selectedModules = action.payload;
    },
    setQueryModules: (state, action) => {
      state.queryModules = action.payload;
    },
    setRunQueryLoading: (state, action) => {
      state.runQueryLoading = action.payload;
    },
    setRunQueryButtonLoading: (state, action) => {
      state.runQueryButtonLoading = action.payload;
    },
    setQueryOutputTableData: (state, action) => {
      state.queryOutputTableData = action.payload;
    },
  },
});

export const {
  setQuaryContent,
  setIsLoading,
  setIsLoadingButtonCreate,
  setIsLoadingButtonEdit,
  setSelectedDatabase,
  setSelectedType,
  setSelectedQueryName,
  setSelectedId,
  setQueryContentSingle,
  setIsPaginationOrSearchClicked,
  setCreateQueryFormData,
  setHasError,
  setCreateQueryFormDataInput,
  setDbMetadataPayload,
  setDbMetaDataPostFailed,
  setOutputValues,
  setCreateBizQueryFailed,
  setCreateBizQueryPayload,
  setEditBizQueryPayload,
  setEditableOutputValues,
  updateEditableOutputField,
  setHasErrorMessage,
  setEditId,
  setEditQueryFormData,
  setEditLoading,
  setEditQueryFormDataInput,
  setLocalMergedOutputData,
  updateLocalMergedOutputData,
  resetLocalMergedOutputData,
  setEditCompleted,
  setSelectedModules,
  setQueryModules,
  setRunQueryLoading,
  setRunQueryButtonLoading,
  setQueryOutputTableData,
} = dataStoreReqSlice.actions;

export default dataStoreReqSlice.reducer;
